'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

function useOutsideClick(handler, mounted = true) {
  const isClicked = react.useRef(false);
  const handleClick = react.useCallback(() => {
    isClicked.current = true;
  }, []);
  const handleEvent = react.useCallback(() => {
    if (isClicked.current) {
      isClicked.current = false;
      return;
    }

    handler();
  }, [handler]);
  react.useEffect(() => {
    if (!mounted) return;
    document.addEventListener("click", handleEvent);
    window.addEventListener("blur", handleEvent);
    return () => {
      document.removeEventListener("click", handleEvent);
      window.removeEventListener("blur", handleEvent);
    };
  }, [handleEvent, mounted]);
  return {
    onClickCapture: handleClick
  };
}

exports.default = useOutsideClick;
